<template>
  <div id="intent">
    <template v-if="!loading">
      <v-container>
        <slot name="header"></slot>
        <v-layout wrap v-if="intents.length > 1 && !isGetstarted">
          <v-flex xs12 sm6 class="form-control">
            <input
              type="text"
              v-model="search"
              class="form-control"
              :placeholder="$t('Search Conversation Name')"
              style="margin-bottom: 10px"
            />
          </v-flex>
          <v-flex xs12 sm6 class="form-control text-xs-right">
            <v-btn class="ma-0 mb-1 mr-1" @click="expandAll" color="primary" outline>
              <i class="fas fa-expand-arrows-alt mr-1"></i>
              {{ $t('Expand All') }}
            </v-btn>
            <v-btn class="ma-0 mb-1 mr-1" @click="collapseAll" color="primary" outline>
              <i class="fas fa-compress mr-1"></i>
              {{ $t('Collapse All') }}
            </v-btn>
          </v-flex>
        </v-layout>
        <template v-if="$route.name != 'livechat'">
          <div v-if="!isShow" :style="`margin-bottom: 10px; position: relative;`">
            <a href="javascript:void(0);" @click="addConversation" style="text-decoration: none">
              <div class="add-conversation text-xs-center">
                <i class="fa fa-plus middle"></i>
                {{ $t('Add conversation') }}
              </div>
            </a>
          </div>

          <div class="mb-4" v-if="selectedBot.theme == 'universalutilities'">
            <div v-if="selectedBot.uu_areaname" class="primary--text">
              {{ selectedBot.uu_areaname }}
            </div>
            <template v-else>
              <multiselect
                v-model="uuAreaName"
                :options="areaName"
                selectLabel
                selectedLabel
                :searchable="false"
                deselect-label
                data-vv-as="ประปา"
                data-vv-name="uuAreaName"
                v-validate="'required'"
                @select="onSelectUuAreaName"
              ></multiselect>
            </template>
          </div>
          <div class="intent-item z-border-red" v-if="isShow" style="padding: 10px 15px 0px">
            <manage-intent
              :type="'add'"
              v-model="intent"
              @close="onClose"
              @saveIntent="onSaveIntent"
              :excludedIntentName="excludedIntentName"
            ></manage-intent>
          </div>
        </template>
        <div v-if="showPagination" class="mt-2 mb-2 text-xs-right">
          <v-pagination :total-visible="15" v-model="pageNumber" :length="pageCount"></v-pagination>
        </div>
        <transition-group
          v-bind:css="false"
          v-on:before-enter="beforeEnter"
          v-on:enter="enter"
          v-on:leave="leave"
        >
          <intent-item
            @sendToLivechat="sendToLivechat"
            v-for="(item, index) in finalIntent"
            :key="'intent_' + item.id + '_' + index"
            v-model="finalIntent[index]"
            :filterIntents="finalIntent"
            @onDelete="deleteIntent(index)"
            @onCopyIntent="copyIntent"
            :excludedIntentName="excludedIntentName"
            @onUpdate="onUpdateIntent"
          ></intent-item>
        </transition-group>

        <div v-if="showPagination" class="mt-2 mb-2 text-xs-right">
          <v-pagination :total-visible="15" v-model="pageNumber" :length="pageCount"></v-pagination>
        </div>
      </v-container>
      <template v-if="showDefault">
        <v-divider></v-divider>

        <v-container>
          <h3 class="headline">{{ $t('Default Conversation') }}</h3>
          <intent-item v-model="default_intent" :welcomemessage="welcome_message"></intent-item>
        </v-container>
      </template>
      <div class="mt-5 mb-5"></div>
    </template>
    <div v-else>
      <v-layout justify-center column fill-height style="min-height: 300px">
        <scale-loader
          :loading="true"
          :color="$vuetify.theme.primary"
          height="45px"
          width="7px"
        ></scale-loader>
      </v-layout>
    </div>
  </div>
</template>

<script>
import Velocity from 'velocity-animate'
import { mapGetters } from 'vuex'
import manageIntent from './intent-manage'
import intentItem from './intent-item'
import api from '@/api'
import Multiselect from 'vue-multiselect'

import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
export default {
  props: {
    showDefault: {
      default: true,
      type: Boolean,
    },
    isGetstarted: {
      default: false,
      type: Boolean,
    },
    filterContext: {
      default: null,
    },
  },
  components: {
    'manage-intent': manageIntent,
    'intent-item': intentItem,
    Multiselect,
    ScaleLoader,
  },
  data() {
    return {
      showPagination: false,
      pageNumber: 1,
      isShow: false,
      showsize: 50,
      showModal: false,
      uuAreaName: '',
      loading: true,
      intent: {
        intentname: '',
        q_type: 'text',
        a_type: 'json',
        q_val: '',
        a_val: '',
        context_in: '',
        context_out: '',
        postidlist: '',
        userstatus: '',
        usertags: '',
        isShow: false,
        userstatus: null,
        usertags: null,
        linenoti_status: false,
        linenoti_text: null,
        starttime: null,
        endtime: null,
        intentstatus: true,
        emo_class: null,
        intent: null,
        topic: null,
        keyword_vec: null,
        similarity: null,
        review: false,
        seven_emo: null,
      },
      allIntents: [],
      intents: [],
      search: '',
      welcome_message: {
        message: '',
        generics: [],
        type: '',
        quick_reply: [],
      },
      isSave: false,
      lastedIntentName: '',
      default_intent: undefined,
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
    }),
    pageCount: function () {
      let l = this.filterIntents.length
      let s = this.showsize
      return Math.ceil(l / s)
    },
    filterIntents: function () {
      var vm = this
      var intents = vm.intents
      if (this.filterContext)
        intents = intents.filter((el) => {
          return el.context_in == this.filterContext
        })
      intents.sort(function (a, b) {
        var nameA = a.intentname.toUpperCase() // ignore upper and lowercase
        var nameB = b.intentname.toUpperCase() // ignore upper and lowercase
        if (a.intentname[0] == '{' && a.intentname[a.intentname.length - 1] == '}') {
          return 1
        }
        if (b.intentname[0] == '{' && b.intentname[b.intentname.length - 1] == '}') {
          return -1
        }
        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }

        // names must be equal
        return 0
      })

      var filteredIntent = intents.filter((intent) => {
        var isFound =
          ((intent.intentname &&
            intent.intentname.toLowerCase().includes(vm.search.toLowerCase())) ||
            (intent.q_val && intent.q_val.toLowerCase().includes(vm.search.toLowerCase())) ||
            (intent.context_in &&
              intent.context_in.toLowerCase().includes(vm.search.toLowerCase())) ||
            (intent.context_out &&
              intent.context_out.toLowerCase().includes(vm.search.toLowerCase())) ||
            (intent.a_val && intent.a_val.toLowerCase().includes(vm.search.toLowerCase()))) &&
          !['comment', 'facebooklive'].includes(intent.context_in)
        return isFound
      })
      return filteredIntent
    },
    finalIntent() {
      if (this.filterIntents.length >= 100) {
        this.showPagination = true
        var start = (this.pageNumber - 1) * this.showsize
        var end = this.pageNumber * this.showsize
        var result = this.filterIntents.slice(start, end)
        return result
      } else {
        this.showPagination = false
        return this.filterIntents
      }
    },

    excludedIntentName: function () {
      var result = []
      var vm = this
      $.each(vm.allIntents, function (index, intent) {
        result.push(intent.intentname)
      })
      return result.join(',')
    },
    areaName: function () {
      var areaName = ['ทุกพื้นที่'].concat(this.$store.state.uuAreaName)
      return areaName
    },
    totalIntentWithoutDefault() {
      var intentwithoutwelcome = this.intents.filter((el) => {
        return !['{welcome}', '{default}', '{default_comment_to_inbox}', '{default_live}'].includes(
          el.intentname
        )
      })
      return intentwithoutwelcome.length
    },
  },
  mounted: async function () {
    var vm = this

    vm.loading = true
    vm.getLineNotify()
    vm.getWelcomeMessage(function () {
      vm.getIntent(function () {
        vm.$emit('getIntent', vm.intents)
        vm.loading = false
      })
    })
    if (['ecommercebasic', 'sahapan', 'nvbb', 'ticket', 'bec'].includes(vm.selectedBot.theme)) {
      vm.$store.dispatch('loadCategory').then(function () {
        vm.$store.dispatch('loadProducts')
      })
      vm.$store.dispatch('loadCharges')
    }
    vm.$store.dispatch('loadSetting')
    if (['ticket'].includes(vm.selectedBot.theme)) {
      await vm.$store.dispatch('loadAgentGroups')
      await vm.$store.dispatch('loadAgentSubGroups')
    }
  },
  methods: {
    // changepage(val) {
    //   var vm = this

    //     this.pagetmp = val
    //     this.getBroadcast(function() {
    //       vm.loading = false
    //     }, 'broadcasted')

    // },
    sendToLivechat(a_val) {
      this.$emit('sendToLivechat', { a_val, type: 'intent' })
    },
    onSelectUuAreaName: function (type) {
      var vm = this
      vm.$store.dispatch('loading')
      vm.uuAreaName = type == 'ทุกพื้นที่' ? '' : type
      vm.getIntent(function () {
        vm.$store.dispatch('loading')
      })
    },
    getLineNotify: function () {
      var vm = this
      return new Promise((resolve, reject) => {
        api.getLineNotify({ pageid: vm.selectedBot.pageid }, function (error, response) {
          if (error) {
            reject(error)
          }
          if (response.linenotifylist) {
            vm.$store.state.linenotifylist = response.linenotifylist
          }
          resolve()
        })
      })
    },
    beforeEnter: function (el) {
      el.style.opacity = 0
      // el.style.height = 0;
    },
    enter: function (el, done) {
      var delay = el.dataset.index * 250
      setTimeout(function () {
        Velocity(el, { opacity: 1 }, { complete: done })
      }, delay)
    },
    leave: function (el, done) {
      var delay = el.dataset.index * 250
      setTimeout(function () {
        Velocity(el, { opacity: 0 }, { complete: done })
      }, delay)
    },
    onSaveIntent: function (payload) {
      var vm = this
      vm.isShow = false
      payload.isShow = true
      vm.intents.push(payload)
      vm.allIntents.push(payload)
      vm.intent = {
        intentname: '',
        q_type: 'text',
        a_type: 'json',
        q_val: '',
        a_val: '[[]]',
        context_in: '',
        context_out: '',
        pageidlist: '',
        usertags: '',
        isShow: false,
        userstatus: null,
        usertags: null,
        linenoti_status: false,
        linenoti_text: null,
        starttime: null,
        endtime: null,
        intentstatus: true,
        emo_class: null,
        intent: null,
        topic: null,
        keyword_vec: null,
        similarity: null,
        review: false,
        seven_emo: null,
      }
      vm.lastedIntentName = payload.intentname
      vm.isSave = true
      vm.onClose()
      vm.isSave = false
      vm.$swal.fire({
        title:
          vm.$t('conversation') +
          ' "' +
          payload.intentname.replace(/\<|\>/g, '') +
          '" ' +
          vm.$t('added'),
        type: 'success',
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true,
      })
    },
    copyIntent: function (payload) {
      if (this.$store.getters.getPackage != 'premium' && this.totalIntentWithoutDefault >= 10) {
        this.$swal
          .fire({
            html: `<b class="intentmax"> ${this.$t(
              'if you want to add more conversation, <br/>please upgrade to premium'
            )}</b>`,
            confirmButtonText: this.$t('Upgrade now'),
            confirmButtonColor: this.$vuetify.theme.primary,
          })
          .then((result) => {
            if (result.value) {
              this.$router.push('Upgrade')
            }
          })
      } else if (
        this.$store.getters.getPackage == 'premium' &&
        this.totalIntentWithoutDefault.length >= 300 &&
        !this.$store.state.UnlimitedConversation.includes(this.selectedBot.pageid) &&
        this.selectedBot.pagetype !== 'enterprise'
      ) {
        this.$swal
          .fire({
            html: `<b class="intentmax"> ${this.$t('Please contact us')}</b>`,
            confirmButtonText: this.$t('Contact us'),
            confirmButtonColor: this.$vuetify.theme.primary,
          })
          .then((result) => {
            if (result.value) {
              window.location.assign('https://www.facebook.com/messages/t/zwizai')
            }
          })
      } else {
        payload.onCopy().then((result) => {
          result.isShow = true
          this.intents.push(result)
          this.allIntents.push(result)
          var vm = this
          vm.$swal.fire({
            title:
              vm.$t('conversation') +
              ' "' +
              result.intentname.replace(/\<|\>/g, '') +
              '" ' +
              vm.$t('added'),
            type: 'success',
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('cancel'),
            reverseButtons: true,
          })
        })
      }
    },
    onClose: function (payload) {
      this.isShow = false
      // this.intents.push(payload)
      // this.getIntent()
    },
    getIntent: function (callback) {
      let vm = this
      let auth = null
      let data = {
        pageid: vm.selectedBot.pageid,
      }
      if (vm.selectedBot.theme == 'universalutilities') {
        if (vm.selectedBot.uu_areaname) {
          data.intentgroup = vm.selectedBot.uu_areaname
        } else if (vm.uuAreaName != '') {
          data.intentgroup = vm.uuAreaName
        }
      }
      api.getIntent(data, function (error, response) {
        if (error) {
          console.error(error)
          return
        }
        if (response.data) {
          var isFoundDefault = false
          var intents = []
          var allIntents = []
          $.each(response.data, function (index, val) {
            var intent = val
            intent.isShow = false
            intent.ableToDelete = true
            allIntents.push(intent)
            if (intent.context_in != 'comment') {
              if (intent.intentname == '{default}') {
                intent.ableToDelete = false
                isFoundDefault = true
                vm.default_intent = intent
              } else if (intent.intentname == '{welcome}') {
              } else {
                intents.push(intent)
              }
            }
          })

          vm.allIntents = allIntents
          vm.intents = intents

          if (!isFoundDefault) {
            vm.default_intent = {
              intentname: '{default}',
              q_type: 'text',
              a_type: 'json',
              q_val: '',
              a_val: '[[]]',
              context_in: '',
              context_out: '',
              ableToDelete: false,
              isShow: false,
              userstatus: null,
              usertags: null,
              linenoti_status: false,
              linenoti_text: null,
              starttime: null,
              endtime: null,
              intentstatus: true,
              emo_class: null,
              intent: null,
              topic: null,
              keyword_vec: null,
              similarity: null,
              review: false,
              seven_emo: null,
            }
          }
        }
        callback()
      })
    },
    deleteIntent: function (index) {
      let vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to delete {name}?', {
            name: vm.finalIntent[index].intentname.replace(/\<|\>/g, ''),
          }),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            let data = {
              id: vm.finalIntent[index].id,
              pageid: vm.selectedBot.pageid,
            }
            vm.$store.dispatch('loading')
            api.deleteIntent(data, function (error, response) {
              if (error) {
                console.error(error)
                vm.$store.dispatch('loading')
                return
              }

              $.each(vm.intents, function (intent_index, intent) {
                if (intent.id == data.id) {
                  vm.intents.splice(intent_index, 1)
                  return false
                }
              })
              if (vm.allIntents) {
                var findIndex = vm.allIntents.find(function (el) {
                  return el.id == data.id
                })

                if (findIndex > -1) {
                  vm.allIntents.splice(findIndex, 1)
                }
              }
              vm.$store.dispatch('loading')
            })
          }
        })
    },
    getWelcomeMessage: function (callback) {
      let vm = this
      let data = {
        pageid: vm.selectedBot.pageid,
      }

      vm.welcome_message.message = null
      vm.welcome_message.generics = [
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: true,
        },
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: false,
        },
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: false,
        },
      ]
      vm.welcome_message.type = 'message'
      api.getWelcomeMessage(data, function (error, response) {
        if (error) {
          console.error(error)
          return
        }
        if (response.data) {
          vm.welcome_message.type = response.data.type
          vm.welcome_message.message = response.data.message_text ? response.data.message_text : ''

          if (
            response.data.message &&
            typeof response.data.message === 'object' &&
            response.data.message.length > 0
          ) {
            $.each(response.data.message, function (index, val) {
              vm.welcome_message.generics[index] = val
            })
          }

          if (
            response.data.message_quickreplies &&
            response.data.message_quickreplies != '' &&
            response.data.message_quickreplies != null
          ) {
            vm.welcome_message.quick_reply = response.data.message_quickreplies.split(',')
          } else {
            vm.welcome_message.quick_reply = []
          }
        }
        callback()
      })
    },
    addConversation() {
      if (this.$store.getters.getPackage != 'premium' && this.totalIntentWithoutDefault >= 10) {
        this.$swal
          .fire({
            html: `<b class="intentmax"> ${this.$t(
              'if you want to add more conversation, <br/>please upgrade to premium'
            )}</b>`,
            confirmButtonText: this.$t('Upgrade now'),
            confirmButtonColor: this.$vuetify.theme.primary,
          })
          .then((result) => {
            if (result.value) {
              this.$router.push('Upgrade')
            }
          })
      } else if (
        this.$store.getters.getPackage == 'premium' &&
        this.totalIntentWithoutDefault >= 300 &&
        !this.$store.state.UnlimitedConversation.includes(this.selectedBot.pageid) &&
        this.selectedBot.pagetype !== 'enterprise'
      ) {
        this.$swal
          .fire({
            html: `<b class="intentmax"> ${this.$t('Please contact us')}</b>`,
            confirmButtonText: this.$t('Contact us'),
            confirmButtonColor: this.$vuetify.theme.primary,
          })
          .then((result) => {
            if (result.value) {
              window.location.assign('https://www.facebook.com/messages/t/zwizai')
            }
          })
      } else {
        this.isShow = true
      }
    },
    expandAll: function () {
      var vm = this
      $.each(vm.intents, function (index, intent) {
        vm.intents[index].isShow = true
      })
      vm.default_intent.isShow = true
    },
    collapseAll: function () {
      var vm = this
      $.each(vm.intents, function (index, intent) {
        vm.intents[index].isShow = false
      })
      vm.default_intent.isShow = false
    },
    onUpdateIntent: function (payload) {
      var vm = this
      $.each(vm.intents, function (index, intent) {
        if (intent.id == payload.id) {
          vm.intents[index] = payload
          return false
        }
      })
    },
  },
  watch: {
    selectedBot: function (newVal, oldVal) {
      if (newVal != oldVal) this.getIntent(function () {})
    },
  },
}
</script>

<style>
.intentmax {
  font-size: 22px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/Intent.vue